import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
	selector: '[randomDelay]'
})
export class randomDelay {

	src:string;
	element: any;

	constructor(private el: ElementRef, private rd: Renderer2) {
		//el.nativeElement.classList.add("wow");
		el.nativeElement.setAttribute("data-wow-delay",Math.random()+'s');
	}

}

